import {
  deletePortraitSheetApi,
  getPortraitFoldersApi,
  saveSelectedPortraitFolders,
  sheetPortraitApi,
  createPortraitSheetApi,
  deleteDigitalPortraitSheetApi,
  createDigitalPortraitSheetApi
} from '@/api/portrait';
import { MAPPING_TYPES } from '@/common/constants';
import { isPortraitMappingChecker } from '@/common/utils';
import { useMappingProject, useMappingSheet } from './mapping';
import { GETTERS as PRINT_GETTERS } from '@/store/modules/print/const';
import { GETTERS as DIGITAL_GETTERS } from '@/store/modules/digital/const';
import { useGetters } from 'vuex-composition-helpers';
import { useAppCommon } from './common';

export const usePortrait = () => {
  const { getMappingConfig } = useMappingProject();
  const { getSheetMappingConfig, updateSheetMappingConfig } = useMappingSheet();
  const { isDigitalEdition } = useAppCommon();
  const isDigital = isDigitalEdition.value;

  const GETTERS = isDigital ? DIGITAL_GETTERS : PRINT_GETTERS;

  const { communityId } = useGetters({
    communityId: GETTERS.COMMUNITY_ID
  });

  const getAndRemovePortraitSheet = async (sheetId, isDigital) => {
    const { collectionIds, id } = await sheetPortraitApi(sheetId, isDigital);
    // do not need to await for the delete api, cuz wont' effect the flow
    if (isDigital) deleteDigitalPortraitSheetApi(id);
    else deletePortraitSheetApi(id);
    return collectionIds;
  };

  const createPortraitSheet = async (sheetId, collectionIds, isDigital) => {
    if (!sheetId) return;
    const { enableContentMapping } = await getMappingConfig();

    // only create portrait sheet mapping if mapping functionality is ON
    if (!enableContentMapping) return;

    // remove previous portrait sheet setting if any
    const { id } = await sheetPortraitApi(sheetId, isDigital);

    if (isDigital) {
      await deleteDigitalPortraitSheetApi(id);

      // create digital portrait sheet settings
      return createDigitalPortraitSheetApi(sheetId, collectionIds);
    }

    await deletePortraitSheetApi(id);

    // create portrait sheet settings
    return createPortraitSheetApi(sheetId, collectionIds);
  };

  /**
   * Status mapping will become OFF.
   * Mapping type will change to PORTRAIT Mapping => all the broken icon will disappear
   *
   * @param {String} sheetId
   */
  const setSheetPortraitConfig = async sheetId => {
    const sheetConfig = await getSheetMappingConfig(sheetId);

    const isPortraitMapping = isPortraitMappingChecker(sheetConfig);
    const isStatusMappingOff = !sheetConfig.mappingStatus;

    const config = {};

    if (!isPortraitMapping) config.mappingType = MAPPING_TYPES.PORTRAIT.value;
    if (!isStatusMappingOff) config.mappingStatus = false;

    await updateSheetMappingConfig(sheetId, config);
  };
  const getPortraitFolders = async bookId => {
    const portraitCollections = await getPortraitFoldersApi({
      bookID: bookId,
      communityId: communityId.value
    });
    return portraitCollections;
  };
  return {
    getPortraitFolders,
    saveSelectedPortraitFolders,
    getAndRemovePortraitSheet,
    createPortraitSheet,
    setSheetPortraitConfig
  };
};
